import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import { user_group } from "../../constants";

const initialState = {
  token: null,
  error: null,
  loading: false,
  group: user_group.Guest,
  signup_done: false
};

const finishSignup = (state, action) => {
    return updateObject(state, {
        signup_done: action.signup_done
    })
}

const joinGroup = (state, action) => {
    return updateObject(state, {
        group: action.group
    })
}

const authStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true
  });
};

const authSuccess = (state, action) => {
  return updateObject(state, {
    token: action.token,
    error: null,
    loading: false
  });
};

const authFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false
  });
};

const authLogout = (state, action) => {
  return updateObject(state, {
    token: null,
    group: user_group.Guest
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);
    case actionTypes.JOIN_GROUP:
        return joinGroup(state, action);
    case actionTypes.SIGNUP_DONE:
        return finishSignup(state, action);
    default:
      return state;
  }
};

export default reducer;
